export default __webpack_public_path__ + "img/icon02.866fd05d.svg";